import type { JSX } from 'solid-js'

/**
 * The dark, high-contrast frame for the guest hub.
 *
 * Scoped deliberately: `dark` is applied here and nowhere else, so the
 * un-migrated flows (top-up, check-in, signup) keep their light styling until
 * they are migrated on purpose. A half-converted app is worse than a scoped one.
 *
 * The palette uses the app's own brand token (`--zc-brand` = #1a1a2e), not an
 * invented one — a venue cloakroom is dim, and this is the surface a guest opens
 * in the queue.
 */
export default function HubShell(props: {
  children: JSX.Element
  onSignOut?: () => void
  /** Opens the detailed items & activity screen. */
  onActivity?: () => void
}) {
  return (
    <div class="dark">
      <div class="min-h-dvh bg-[#1a1a2e] text-white flex flex-col">
        <header class="border-b border-white/10 px-4 py-3">
          <div class="max-w-md mx-auto flex items-center justify-between">
            <div class="flex items-center gap-2">
              <img src="/logo.svg" alt="" class="h-6" />
              <span class="font-semibold">ZipCheck</span>
            </div>
            <div class="flex items-center gap-4">
              <button
                type="button"
                onClick={() => props.onActivity?.()}
                class="text-sm text-white/60 hover:text-white transition-colors"
              >
                My items
              </button>
              <button
                type="button"
                onClick={() => props.onSignOut?.()}
                class="text-sm text-white/60 hover:text-white transition-colors"
              >
                Sign out
              </button>
            </div>
          </div>
        </header>
        <main class="flex-1 p-4">
          <div class="max-w-md mx-auto space-y-4">{props.children}</div>
        </main>
      </div>
    </div>
  )
}
